import React from 'react';
import { toast, ToastContainer } from "react-toastify";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import AutosizeInput from "react-input-autosize";
import moment from "moment";
import {
  Container, Form, Button, Dropdown,
  Spinner,
  OverlayTrigger, Tooltip

} from "react-bootstrap";

import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { SingleSearchDropdownList } from "../../Common/Components/SingleSearchDropdownList";
import { Utils } from "../../Common/Utilis";
import { ConfirmationModal } from "../../Common/Components/ConfirmationModal";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { CommentBox } from "../../Common/Components/CommentBox";
import { PartTemplateService } from "../../Common/Services/PartTemplateService";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { User } from "../../Common/Services/User";
import { faArrowUp, faListSquares } from "@fortawesome/free-solid-svg-icons";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { JobServices } from "../../Common/Services/JobServices";
// import { Vendororderslideout } from './Vendororderslideout';
import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import { FaArrowUpFromBracket, FaCircleMinus, FaCirclePlus, FaEllipsis } from "react-icons/fa6";
import { FaChevronRight, FaSearch, FaFilter } from "react-icons/fa";
import { MdDesignServices } from "react-icons/md";
import { FaLaptopHouse } from 'react-icons/fa';
import  Vendororderslideout from '../Vendororderslideout';
import  JobCreations  from '../JobCreations';
import  Receivableslideout  from '../Accounts/Receivableslideout';
import NCRSlideout from '../Job/NCRSlideout';
import { ShippingSlideout } from '../ShippingSlideout';
import Customerorderslideout from '../Customerorderslideout';
const { SearchBar } = Search;
// const DOMPurify = createDOMPurify(window);
const renderTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Select Process
  </Tooltip>
);
export class Overview extends React.Component<any, any> {
  private child: any;
  private overviewDelayTimer: any = null;
  private overviewAbortController: AbortController | null = null;
  private hasFetchedOverviewData: boolean = false;

  constructor(props: any) {

    super(props);
    this.getoverviewdata = this.getoverviewdata.bind(this);
   // this.handleSelectedItem1=this.handleSelectedItem1(this);
    this.state = {
      isSpinner: true,
      selectedcolumn: "All",
      iscustpo:true,
      iscustnm:true,

      isvendornm:true,
      ispart:true,

      isjob:true,
      isvendorno:true,
      isinvoice:true,
      ismaterial:true,
      isshipping:true,
      isorderdate:true,
      isncr:true,
      Partorders: 0,
      JobCreated: 0,
      vendorpendingorders: 0,
      isFirst: 0,
      vendorsent: 0,
      vendorreceived: 0,
      overviewdata: [],
      partoverviewdata: [],
      joboverviewdata: [],
      customeroverviewdata: [],
      processselectedRows: [],
      invoverviewdata: [],
      expandedNodes: {},
      selectedOrder: null,
      selectedPart: null,
      selectedJob: null,
      viewMode: 'tree', // 'cards' or 'tree'
      treeSearchTerm: '',
     // columns: this.columns,
      pcolumns: this.pcolumns,
      partcolumns: this.partcolumns,
      jobcolumns: this.jobcolumns,
      ncolumns: this.ncolumns,
      icolumns: this.icolumns,
      vcolumns: this.vcolumns,
      mcolumns: this.mcolumns,
      scolumns: this.scolumns,

      selectOptions: [{
        id: 'All', name: 'All'
      },
      { id: 'Customer PO #', name: 'Customer PO No.' },
      { id: 'Customer Name', name: 'Customer Name' },
      { id: 'Vendor Name', name: 'Vendor Name' },
      { id: 'Part #', name: 'Part No.' },
      { id: 'Job #', name: 'Job No.' },
      { id: 'Vendor No.', name: 'Vendor No.' },
      { id: 'Material', name: 'Material' },
      { id: 'Shipping No', name: 'Shipping No' },

      { id: 'Order Date', name: 'Order Date' },

      { id: 'NCR', name: 'NCR' },
      ],


    };




  }

  handleSelectedItem1 = (control: any, id: any) => {
    let overviewdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.overviewdata))
    );




    let iscustpo = id == 'Customer PO #' ? true : false;
    let iscustnm = id == 'Customer Name' ? true : false;
    let isvendornm = id == 'Vendor Name' ? true : false;
    let ispart = id == 'Part #' ? true : false;
    let isjob = id == 'Job #' ? true : false;
    let isvendorno = id == 'Vendor No.' ? true : false;
    let isinvoice = id == 'Invoice No.' ? true : false;
    let ismaterial = id == 'Material' ? true : false;
    let isshipping = id == 'Shipping No' ? true : false;

    let isorderdate = id == 'Order Date' ? true : false;

    let isncr = id == 'NCR' ? true : false;

    if (id == "All") {
      iscustpo = true;
      iscustnm = true;
      isvendornm = true;
      ispart = true;

      isjob = true;
      isvendorno = true;
      isinvoice = true;
      ismaterial = true;
      isshipping = true;
      isorderdate = true;
      isncr = true;
    }


    this.setState({
      overviewdata: [], selectedcolumn: id, iscustpo: iscustpo, iscustnm: iscustnm, isvendornm: isvendornm, ispart: ispart, isjob: isjob,
      isvendorno: isvendorno, isinvoice: isinvoice,
      ismaterial: ismaterial, isshipping: isshipping,
      isorderdate: isorderdate, isncr: isncr,
    },
      () => {
        this.setState({ overviewdata: overviewdata });

        // If in tree view, trigger a re-render to apply the filter
        if (this.state.viewMode === 'tree') {
          this.forceUpdate();
      }
      }
    );

  };



  private partcolumns = [
    {
      dataField: "rowId",
      text: "rowid",
      hidden: true,
    },
    {
      dataField: "orderId",
      text: "id",
      hidden: true,
    },
    {
      dataField: "partNumber",
      text: "Part Number",
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          <>
            {/* <div>{row.partNumber}</div> */}


            <OverlayTrigger placement="top"
              overlay={<Tooltip id={String(row.rowId)}>{row.partName}, Order Qty - {row.qtyOrdered}</Tooltip>}>
              <div>{row.partNumber}</div>

            </OverlayTrigger>

          </>
        );
      },
    },
  ];

  private jobcolumns = [
    {
      dataField: "rowId",
      text: "rowid",
      hidden: true,
    },
    {
      dataField: "orderId",
      text: "id",
      hidden: true,
    },
    {
      dataField: "jobNumber",
      text: "Job Number",

    },
  ];



  private mcolumns = [
    {
      dataField: "rowId",
      text: "rowid",
      hidden: true,
    },
    {
      dataField: "orderId",
      text: "id",
      hidden: true,
    },


    {
      dataField: "material",
      text: "Material",

    },

  ];


  private pcolumns = [
    {
      dataField: "rowId",
      text: "rowid",
      hidden: true,
    },
    {
      dataField: "orderId",
      text: "id",
      hidden: true,
    },

    {
      dataField: "jobId",
      text: "jobId",
      hidden: true,
    },

    {
      dataField: "process",
      text: "Process",
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          <div>
            {row.process}
            {row.trackerStatus != '' && row.trackerStatus != 'NCR' &&
              <span className="badge badge-pill badge-primary color-green"> {row.trackerStatus == "progress" ? "running" : row.trackerStatus} </span>}

            {row.ncr != '' &&


              <span className="badge badge-pill badge-primary color-red"> {row.ncr} </span>

            }



          </div>
        );
      },
    },

  ];




  private vcolumns = [
    {
      dataField: "rowId",
      text: "rowid",
      hidden: true,
    },
    {
      dataField: "orderId",
      text: "id",
      hidden: true,
    },

    {
      dataField: "jobId",
      text: "jobId",
      hidden: true,
    },
    {
      dataField: "vendorOrderId",
      text: "vendororderId",
      hidden: true,
    },


    {
      dataField: "vendorOrder",
      text: "Vendor Order",

    },

  ];


  private scolumns = [
    {
      dataField: "rowId",
      text: "rowid",
      hidden: true,
    },
    {
      dataField: "jobId",
      text: "jobId",
      hidden: true,
    },
    {
      dataField: "orderId",
      text: "id",
      hidden: true,
    },
    {
      dataField: "shipmentid",
      text: "shipmentid",
      hidden: true,
    },

    {
      dataField: "shipping",
      text: "Shipping",

    },

  ];

  private icolumns = [
    {
      dataField: "rowId",
      text: "rowid",
      hidden: true,
    },
    {
      dataField: "orderId",
      text: "id",
      hidden: true,
    },
    {
      dataField: "invoiceId",
      text: "invoiceId",
      hidden: true,
    },

    {
      dataField: "productId",
      text: "productId",
      hidden: true,
    },

    {
      dataField: "invoice",
      text: "Invoice",
      classes: "table-activeselected",
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          <div>
            {row.invoice}
            {row.paymentDate != null &&


              <span className="badge badge-pill badge-primary color-green"> received </span>

            }
          </div>
        );
      },
    },

  ];

  private ncolumns = [
    {
      dataField: "rowId",
      text: "rowid",
      hidden: true,
    },
    {
      dataField: "jobId",
      text: "jobId",
      hidden: true,
    },
    {
      dataField: "orderId",
      text: "id",
      hidden: true,
    },



    {
      dataField: "ncr",
      text: "NCR",

    },

  ];
  componentDidMount() {
    this.setState({ isSpinner: true });

    this.overviewDelayTimer = setTimeout(() => {
      this.getoverviewdata();
    }, 2500);
  }

  componentWillUnmount() {
    if (this.overviewDelayTimer) {
      clearTimeout(this.overviewDelayTimer);
      this.overviewDelayTimer = null;
    }
    if (this.overviewAbortController) {
      this.overviewAbortController.abort();
      this.overviewAbortController = null;
    }
  }

  showncrslideout = () => {

    this.setState({ showncrslideout: true });
  };

  getoverviewdata = () => {
    if (this.hasFetchedOverviewData) return;
    this.hasFetchedOverviewData = true;

    if (this.overviewAbortController) {
      this.overviewAbortController.abort();
    }
    this.overviewAbortController = new AbortController();

    let request: any = {};

    JobServices.GetOverviewdata(request, { signal: this.overviewAbortController.signal })
      .then(async (resultinv: any | null) => {
        if (resultinv !== null && resultinv.length > 0) {
          this.setState({ 
            overviewdata: resultinv, 
            customeroverviewdata: resultinv, 
            partoverviewdata: resultinv, 
            joboverviewdata: resultinv, 
            invoverviewdata: resultinv,
            isSpinner: false 
          }, () => {
            this.handleTemplateOnDefault(resultinv[0].orderId, true);
          });
        } else {
          this.setState({ isSpinner: false });
        }
      })
      .catch((error) => {
        if (error?.name !== 'CanceledError' && error?.name !== 'AbortError') {
          this.setState({ isSpinner: false });
        }
      });
  };


  handlepartOnSelect = (row, isSelect) => {
    this.handleTemplateOnSelect(row,isSelect);
    let partoverviewdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.partoverviewdata))
    );
    let joboverviewdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.joboverviewdata))
    );
    let overviewdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.overviewdata))
    );
    let jobselected: any;
    let partselected: any;
    joboverviewdata.forEach(element => {
      if (element.productId == row.productId) {

        element.selected = isSelect;

        partselected = element.productId;
        jobselected = element.jobId;




      }
      else
        element.selected = false;
    });
    ;
    overviewdata.filter(o => o.orderId == row.orderId && o.productId == partselected);
    this.setState({ overviewdata: [], selectedTemplateId: row.orderId, partselected: partselected, jobselected: jobselected, isSpinner: false }, () => {

      this.setState({ overviewdata: overviewdata, partoverviewdata: partoverviewdata, joboverviewdata: joboverviewdata
       });
      //  this.getProcessDataforPopup(row.id);

    });

  };

  handlejobOnSelect = (row, isSelect) => {
    let partoverviewdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.partoverviewdata))
    );
    let joboverviewdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.joboverviewdata))
    );
    let overviewdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.overviewdata))
    );
    let jobselected: any;
    let partselected: any;
    let showJobSlideout = false;
    joboverviewdata.forEach(element => {
      if (element.productId == row.productId) {

        if (element.selected == true) {

          showJobSlideout = true;
        }


        element.selected = isSelect;

        partselected = element.productId;
        jobselected = element.jobId;




      }
      else
        element.selected = false;
    });

    overviewdata.filter(o => o.orderId == row.orderId && o.productId == partselected);
    this.setState({ overviewdata: [], selectedTemplateId: row.orderId, partselected: partselected, jobselected: jobselected, isSpinner: false }, () => {

      this.setState({ 
        // showJobSlideout: showJobSlideout, 
        showMessage: (
          <span>
            You have selected Job No.{' '}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                this.setState({showJobSlideout: true});
              }}
              className="orderLinks"
              style={{fontSize:'15px'}}
            >
              {row.jobNumber}
            </a>
          </span>
        ),
        jobid: row.jobId, productid: row.productId, orderdetailid: row.orderdetailid, orderid: row.orderId, jobNo: row.jobNumber, overviewdata: overviewdata, partoverviewdata: partoverviewdata, joboverviewdata: joboverviewdata });
      //  this.getProcessDataforPopup(row.id);

    });

  };

  handleTemplateOnSelect = (row, isSelect) => {
    let {

      processselectedRows,

    } = this.state;

    let customeroverviewdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.customeroverviewdata))
    );

    let partoverviewdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.partoverviewdata))
    );

    let invoverviewdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.invoverviewdata))
    );



    partoverviewdata = [];
    let joboverviewdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.customeroverviewdata))
    );
    let showCustomerSlideout = false;

    let partselected: any;
    let jobselected: any;
    let invoiceselected: any;
    customeroverviewdata.forEach(element => {
      if (element.orderId == row.orderId) {


        if (element.selected == true) {

          showCustomerSlideout = true;
        }
        element.selected = isSelect;
        if (partselected == undefined) {
          partselected = element.productId;
        }

        if (jobselected == undefined) {
          jobselected = element.jobId;
        }
        //invoiceselected=element.invoiceId;
        


        processselectedRows = [...this.state.processselectedRows, row.invoiceId];

        let item: any = {};
        item.rowId = element.rowId;
        item.orderId = element.orderId;
        item.productId = element.productId;
        item.partNumber = element.partNumber;
        item.partName = element.partName;
        item.qtyOrdered = element.qtyOrdered;
        item.selected = isSelect;
        partoverviewdata.push(item);
      }
      else
        element.selected = false;
    });


    invoverviewdata.forEach(element => {
      element.selected = true;
    });

    var jobdata = joboverviewdata.filter(o => o.orderId == row.orderId);

    this.setState({ orderid: row.orderId, overviewdata: [], invoverviewdata: invoverviewdata, processselectedRows: processselectedRows.filter(o => o != undefined || o != null), customeroverviewdata: customeroverviewdata, selectedTemplateId: row.orderId, partselected: partselected, jobselected: jobselected, isSpinner: false }, () => {
      this.setState({ 
        // showCustomerSlideout: showCustomerSlideout,
        showMessage: (
          <span>
            You have selected {row.customerOrder?'Order No.':'Part No.'}{' '}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                this.setState({showCustomerSlideout: true});
              }}
              className="orderLinks"
              style={{fontSize:'15px'}}
            >
              {row.customerOrder?row.customerOrder:row.partNumber}
            </a>
          </span>
        ),
         overviewdata: customeroverviewdata, partoverviewdata: partoverviewdata, joboverviewdata: jobdata });
      //  this.getProcessDataforPopup(row.id);
    });

  };

  toggleNode = (nodeId: string) => {
    this.setState(prevState => ({
      expandedNodes: {
        ...prevState.expandedNodes,
        [nodeId]: !prevState.expandedNodes[nodeId]
      }
    }));
  };

  selectOrder = (order: any) => {
    this.setState({
      selectedOrder: order,
      selectedPart: null,
      selectedJob: null,
      selectedTemplateId: order.orderId
    });
  };

  selectPart = (part: any) => {
    this.setState({
      selectedPart: part,
      selectedJob: null,
      partselected: part.productId
    });
  };

  selectJob = (job: any) => {
    this.setState({
      selectedJob: job,
      jobselected: job.jobId
    });
  };

  toggleViewMode = () => {
    this.setState(prevState => ({
      viewMode: prevState.viewMode === 'cards' ? 'tree' : 'cards'
    }));
    
    // Sync selections when switching views
    if (this.state.selectedOrder) {
      this.setState({
        selectedTemplateId: this.state.selectedOrder.orderId
      });
    }
    if (this.state.selectedPart) {
      this.setState({
        partselected: this.state.selectedPart.productId
      });
    }
    if (this.state.selectedJob) {
      this.setState({
        jobselected: this.state.selectedJob.jobId
      });
    }
  };

  handleTreeSearch = (searchTerm: string) => {
    this.setState({ treeSearchTerm: searchTerm });
  };

  getFilteredOrders = () => {
    const { treeSearchTerm } = this.state;
    let orders = this.state.customeroverviewdata.filter((ele, ind) => 
      ind === this.state.customeroverviewdata.findIndex(elem => elem.orderId === ele.orderId)
    );

    console.log('All orders before filtering:', orders);
    console.log('Search term:', treeSearchTerm);

    if (treeSearchTerm) {
      orders = orders.filter(order => {
        const orderMatch = (order.customerOrder || '').toLowerCase().includes(treeSearchTerm.toLowerCase()) ||
                          (order.customerName || '').toLowerCase().includes(treeSearchTerm.toLowerCase());
        
        // Use overviewdata for more comprehensive search
        const partsMatch = this.state.overviewdata.some(part => 
          part.orderId === order.orderId && 
          ((part.partNumber || '').toLowerCase().includes(treeSearchTerm.toLowerCase()) ||
           (part.partName || '').toLowerCase().includes(treeSearchTerm.toLowerCase()))
        );
        
        const jobsMatch = this.state.overviewdata.some(job => 
          job.orderId === order.orderId && 
          (job.jobNumber || '').toLowerCase().includes(treeSearchTerm.toLowerCase())
        );

        const materialMatch = this.state.overviewdata.some(item => 
          item.orderId === order.orderId && 
          (item.material || '').toLowerCase().includes(treeSearchTerm.toLowerCase())
        );

        const processMatch = this.state.overviewdata.some(item => 
          item.orderId === order.orderId && 
          (item.process || '').toLowerCase().includes(treeSearchTerm.toLowerCase())
        );

        const vendorMatch = this.state.overviewdata.some(item => 
          item.orderId === order.orderId && 
          (item.vendorOrder || '').toLowerCase().includes(treeSearchTerm.toLowerCase())
        );

        const shippingMatch = this.state.overviewdata.some(item => 
          item.orderId === order.orderId && 
          (item.shipping || '').toLowerCase().includes(treeSearchTerm.toLowerCase())
        );

        const invoiceMatch = this.state.overviewdata.some(item => 
          item.orderId === order.orderId && 
          (item.invoice || '').toLowerCase().includes(treeSearchTerm.toLowerCase())
        );

        return orderMatch || partsMatch || jobsMatch || materialMatch || processMatch || vendorMatch || shippingMatch || invoiceMatch;
      });
    }

    console.log('Filtered orders:', orders);
    return orders;
  };

  handleTemplateOnDefault = (row, isSelect) => {
    let {

      processselectedRows,

    } = this.state;
    let customeroverviewdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.customeroverviewdata))
    );

    let partoverviewdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.partoverviewdata))
    );
    let invoverviewdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.invoverviewdata))
    );


    partoverviewdata = [];
    let joboverviewdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.customeroverviewdata))
    );

    let partselected: any;
    let jobselected: any;

    customeroverviewdata.forEach(element => {
      if (element.orderId == row) {

        element.selected = isSelect;
        if (partselected == undefined) {
          partselected = element.productId;
        }

        if (jobselected == undefined) {
          jobselected = element.jobId;
        }

        processselectedRows = [...this.state.processselectedRows, row.invoiceId];
        let item: any = {};
        item.rowId = element.rowId;
        item.orderId = element.orderId;
        item.productId = element.productId;
        item.partNumber = element.partNumber;
        item.partName = element.partName;
        item.qtyOrdered = element.qtyOrdered;
        item.selected = isSelect;
        partoverviewdata.push(item);
      }
      else
        element.selected = false;
    });


    // invoverviewdata.forEach(element => {
    //   element.selected = true;
    // });

    var jobdata = joboverviewdata.filter(o => o.orderId == row);

    this.setState({ invoverviewdata: invoverviewdata, processselectedRows: processselectedRows, customeroverviewdata: customeroverviewdata, selectedTemplateId: row, partselected: partselected, jobselected: jobselected, isSpinner: false }, () => {

      this.setState({ overviewdata: customeroverviewdata, partoverviewdata: partoverviewdata, joboverviewdata: jobdata });
      //  this.getProcessDataforPopup(row.id);
    });

  };

  handleVendorOnSelect = (row) => {

    this.setState({ 
      // showSlideout: true,
       id: row.vendorOrderId, customerpo: row.vendorOrder, vendororderid: row.vendorOrderId, jobid: row.jobId, orderid: row.orderId ,
      showMessage: (
        <span>
          You have selected Vendor Order{' '}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              // this.handleVendorOnSelect(row);
              this.setState({showSlideout: true});
            }}
            className="orderLinks"
            style={{fontSize:'15px'}}
            >
            {row.vendorOrder}
          </a>
        </span>
      ),});
  };


  handleShippingOnSelect = (row) => {
    this.setState({ 
      // showShippingSlideout: true, 
      shipmentid: row.shipmentid, jobIds: this.state.overviewdata.filter(x => x.selected === true).map(r => r.jobId), orderid: row.orderId,
      showMessage: (
        <span>
          You have selected Shipping{' '}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              // this.handleShippingOnSelect(row);
              this.setState({showShippingSlideout: true});
            }}
            className="orderLinks"
            style={{fontSize:'15px'}}
            >
            {row.shipping}
          </a>
        </span>
      ),
     });
  };
  
  handlepprocessOnSelect = (row) => {
    // if (row.trackerStatus == "NCR") {
      this.setState({ 
        // showNCRSlideout: row.trackerStatus = "NCR" ? true : false, 
        jobid: row.jobId, orderid: row.orderId ,
        showMessage: (
          <span>
            You have selected process with Job No.{' '}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                // this.handlepprocessOnSelect(row);
                // this.setState({showNCRSlideout: row.trackerStatus = "NCR" ? true : false});
                this.setState({showJobSlideout: true});
              }}
              className="orderLinks"
              style={{fontSize:'15px'}}
            >
              {row.jobNumber}
            </a>
          </span>
        )
      });

    // }
  };

  handleMaterialOnSelect = (row) => {
    // if (row.trackerStatus == "NCR") {
      this.setState({ 
        // showNCRSlideout: row.trackerStatus = "NCR" ? true : false, 
        jobid: row.jobId, orderid: row.orderId ,
        showMessage: (
          <span>
            You have selected Material{' '}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                // this.handlepprocessOnSelect(row);
                // this.setState({showNCRSlideout: row.trackerStatus = "NCR" ? true : false});
                this.setState({showJobSlideout: true});
              }}
              className="orderLinks"
              style={{fontSize:'15px'}}
            >
              {row.material}
            </a>
          </span>
        )
      });

    // }
  };

  handleInvoiceOnSelect = (row) => {
    this.setState({
      // showReceivableslideout: true,
     invoiceId: row.invoiceId, jobid: row.jobId, orderid: row.orderId,
      showMessage: (
        <span>
          You have selected Invoice{' '}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              // this.handleInvoiceOnSelect(row);
              this.setState({showReceivableslideout: true});
            }}
            className="orderLinks"
            style={{fontSize:'15px'}}
            >
            {row.invoice}
          </a>
        </span>
      ),
      orderIds: this.state.overviewdata.filter(x => x.selected === true).map(r => r.orderId),

      products: this.state.overviewdata.filter(x => x.selected === true).map(r => r.productId),

    });

  };


  closeSlideOut = () => {
    this.setState({ showSlideout: false, showCustomerSlideout: false, showNCRSlideout: false, showShippingSlideout: false, isSpinner: false, });

  };

  closeJobSlideout = () => {
    this.setState({ showJobSlideout: false, isSpinner: false, });

  };
  closeInvoiceSlideOut = () => {
    this.setState({ showReceivableslideout: false, isSpinner: false, });

  };

  render() {

    const columns = [
      {
        dataField: "orderId",
        text: "id",
        hidden: true,
      },
      {
        dataField: "customerName",
        text: "Customer Order",
        hidden: true,
        searchable: this.state.iscustnm,
      },
      {
        dataField: "vendorName",
        text: "Customer Order",
        hidden: true,
        searchable: this.state.isvendornm,
      },
      {
        dataField: "orderDate",
        text: "Customer Order",
        hidden: true,
        searchable: this.state.isorderdate,
      },
      {
        dataField: "partNumber",
        text: "Customer Order",
        hidden: true,
        searchable: this.state.ispart,
      },
      {
        dataField: "partName",
        text: "Customer Order",
        hidden: true,
        searchable: this.state.ispartname,
      },
      {
        dataField: "invoice",
        text: "Customer Order",
        hidden: true,
        searchable: this.state.isinvoice,
      },
      {
        dataField: "jobNumber",
        text: "Job Number",
        hidden: true,
        searchable: this.state.isjob,
      },
  
      {
        dataField: "material",
        text: "Material",
        hidden: true,
        searchable: this.state.ismaterial,
      },
  
      {
        dataField: "vendorOrder",
        text: "Vendor Order",
        hidden: true,
        searchable: this.state.isvendorno,
      },
  
      {
        dataField: "shipping",
        text: "Shipping",
        hidden: true,
        searchable: this.state.isshipping,
      },
      {
        dataField: "ncr",
        text: "NCR",
        hidden: true,
        searchable: this.state.isncr,
      },
      {
        dataField: "customerOrder",
        text: "Cust. PO#",
  
        searchable: this.state.iscustpo,
      },
  
    ];
    const {
      showCustomerSlideout,
      showSlideout,
      showJobSlideout,
      showReceivableslideout,
      showNCRSlideout,
      showShippingSlideout,
    } = this.state;

    const popUpState = localStorage?.getItem("PopUpState") ? JSON.parse(localStorage?.getItem("PopUpState") || "") : {};




    return (
      <>
        <style>
          {`
            .tree-container {
              background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);
              border-radius: 18px;
              padding: 1.25rem;
              margin-bottom: 1rem;
              border: 1px solid #dfe7f1;
              box-shadow: 0 16px 40px rgba(27, 39, 51, 0.08);
            }

            .tree-header {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              gap: 1rem;
              margin-bottom: 1rem;
            }

            .tree-title-block h5 {
              margin-bottom: 0.35rem;
              font-weight: 800;
              letter-spacing: -0.02em;
              color: #18324a;
            }

            .tree-title-block p {
              margin-bottom: 0;
              color: #5d7185;
              font-size: 0.92rem;
            }

            .tree-summary-bar {
              display: flex;
              flex-wrap: wrap;
              gap: 0.65rem;
              justify-content: flex-end;
            }

            .tree-summary-pill {
              display: inline-flex;
              align-items: center;
              gap: 0.5rem;
              padding: 0.55rem 0.8rem;
              border-radius: 999px;
              background: #eef4fb;
              color: #24425d;
              font-size: 0.86rem;
              font-weight: 700;
              border: 1px solid #d6e2ee;
              white-space: nowrap;
            }

            .tree-summary-pill strong {
              color: #10263a;
            }

            .tree-summary-pill.accent {
              background: linear-gradient(135deg, #173a5e 0%, #24507d 100%);
              color: #fff;
              border-color: transparent;
            }

            .tree-summary-pill.accent strong {
              color: #fff;
            }
            
            .tree-node {
              margin-bottom: 0.85rem;
            }
            
            .tree-node-header {
              display: flex;
              align-items: center;
              gap: 0.75rem;
              padding: 0.9rem 1rem;
              background: #ffffff;
              border-radius: 14px;
              cursor: pointer;
              transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, background 0.18s ease;
              border: 1px solid #dce5ef;
              box-shadow: 0 8px 18px rgba(27, 39, 51, 0.04);
              position: relative;
              overflow: hidden;
            }

            .tree-node-header::before {
              content: "";
              position: absolute;
              left: 0;
              top: 0;
              bottom: 0;
              width: 4px;
              background: linear-gradient(180deg, #ff8a3d 0%, #ffb06b 100%);
            }
            
            .tree-node-header:hover {
              transform: translateY(-1px);
              border-color: #9bc0e4;
              box-shadow: 0 12px 26px rgba(27, 39, 51, 0.09);
            }
            
            .tree-node-header.active {
              background: linear-gradient(180deg, #f0f7ff 0%, #ffffff 100%);
              border-color: #8eb8e3;
              box-shadow: 0 14px 28px rgba(27, 39, 51, 0.1);
            }
            
            .tree-node-icon {
              color: #225780;
              font-size: 1rem;
              transition: transform 0.2s ease;
              flex-shrink: 0;
            }
            
            .tree-node-icon.expanded {
              transform: rotate(90deg);
            }
            
            .tree-node-title {
              font-weight: 600;
              color: #18324a;
              flex-grow: 1;
              min-width: 0;
            }
            
            .tree-node-count {
              background: linear-gradient(135deg, #20537f 0%, #2e6da5 100%);
              color: white;
              padding: 0.35rem 0.65rem;
              border-radius: 999px;
              font-size: 0.74rem;
              font-weight: 600;
              flex-shrink: 0;
            }
            
            .tree-node-content {
              margin-left: 0.9rem;
              margin-top: 0.65rem;
              border-left: 2px solid #d6e2ee;
              padding-left: 1rem;
            }
            
            .tree-sub-node {
              margin-bottom: 0.45rem;
              padding: 0.65rem 0.8rem;
              background: #ffffff;
              border-radius: 12px;
              border: 1px solid #dde6ef;
              cursor: pointer;
              transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
              box-shadow: 0 6px 16px rgba(27, 39, 51, 0.035);
            }
            
            .tree-sub-node:hover {
              transform: translateY(-1px);
              border-color: #9bc0e4;
              box-shadow: 0 10px 24px rgba(27, 39, 51, 0.08);
            }
            
            .tree-sub-node.selected {
              background: linear-gradient(180deg, #f2f8ff 0%, #ffffff 100%);
              border-color: #86aed7;
              box-shadow: 0 10px 24px rgba(34, 87, 128, 0.1);
            }
            
            .tree-sub-node-title {
              font-weight: 500;
              color: #24425d;
              font-size: 0.9rem;
              text-decoration: none;
              outline: none;
              display: flex;
              align-items: center;
              gap: 0.5rem;
              flex-wrap: wrap;
            }
            
            .tree-sub-node-title:hover,
            .tree-sub-node-title:focus,
            .tree-sub-node-title:active,
            .tree-sub-node-title:visited {
              text-decoration: none !important;
              outline: none !important;
              color: #495057 !important;
              border-bottom: none !important;
            }
            
            .tree-sub-node-details {
              font-size: 0.8rem;
              color: #6b7f93;
              margin-top: 0.35rem;
              display: flex;
              flex-wrap: wrap;
              gap: 0.4rem 0.75rem;
            }
            
            .tree-tab-link {
              color: #20537f;
              text-decoration: none;
              font-weight: 500;
              cursor: pointer;
              transition: color 0.2s ease;
            }
            
            .tree-tab-link:hover {
              color: #173a5e;
              text-decoration: underline;
            }
            
            .view-toggle {
              margin-bottom: 1rem;
              text-align: right;
            }
            
            .view-toggle button {
              background: #007bff;
              color: white;
              border: none;
              padding: 0.5rem 1rem;
              border-radius: 4px;
              cursor: pointer;
              transition: background 0.2s ease;
            }
            
            .view-toggle button:hover {
              background: #0056b3;
            }
            
            .search-filter-section {
              background: #ffffff;
              border-radius: 14px;
              padding: 1rem;
              margin-bottom: 1rem;
              border: 1px solid #dce5ef;
              box-shadow: 0 10px 24px rgba(27, 39, 51, 0.04);
            }
            
            .search-filter-section .form-control {
              border: 1px solid #cfd8e3;
              border-radius: 999px;
              padding: 0.5rem 0.75rem;
              font-size: 0.9rem;
              transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
            }
            
            .search-filter-section .form-control:focus {
              border-color: #2e6da5;
              box-shadow: 0 0 0 0.2rem rgba(46, 109, 165, 0.15);
            }

            .tree-empty-state {
              padding: 1.5rem;
              border: 1px dashed #bfd0e1;
              border-radius: 14px;
              text-align: center;
              color: #60748a;
              background: #fbfdff;
            }

          `}
        </style>



        <Container fluid className="body-sec">
          <div className="page-heading underline d-flex  ">

            Overview
            <div className="action-group d-flex flex-row ml-auto">
              {/* <Button onClick={this.shownewslideout}>Add Customer Order</Button> */}
            </div>
          </div>

          {/* View Toggle */}
          <div className="view-toggle">
            <button onClick={this.toggleViewMode}>
              {this.state.viewMode === 'cards' ? 'Switch to Tree View' : 'Switch to Card View'}
            </button>
          </div>


          <section className="mt-3">

            {this.state.isSpinner ? (
              <div className="d-flex flex-column align-items-center justify-content-center py-5 my-4" style={{ minHeight: '320px', backgroundColor: '#ffffff', borderRadius: '14px', border: '1px solid #dce5ef', boxShadow: '0 10px 24px rgba(27, 39, 51, 0.04)' }}>
                <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
                  <span className="sr-only">Loading...</span>
                </div>
                <h6 style={{ color: '#18324a', fontWeight: 600, margin: 0 }}>Loading Overview Data...</h6>
                <small className="text-muted mt-1">Preparing orders, parts, jobs, materials, and processes</small>
              </div>
            ) : (
            <section >
              {/* Tree View */}
              {this.state.viewMode === 'tree' && (
                <div className="tree-container">
                  <h5 className="mb-3">Order Overview Tree</h5>
                  
                  {/* Search and Filter for Tree View */}
                  <div className="search-filter-section mb-3">
                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <div className="d-flex align-items-center">
                          <FaSearch className="me-3 text-primary" size={16} />
                          <div className="flex-grow-1">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search orders, parts, jobs, materials, processes, vendor orders, shipping, invoices..."
                              value={this.state.treeSearchTerm || ''}
                              onChange={(e) => this.handleTreeSearch(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                      <div className="row align-items-center">
                        <div className="col-auto pe-0">
                          <FaFilter className="text-primary" size={16} />
                        </div>

                        <div className="col">
                          <SingleDropdownListWithoutSearch
                            itemList={this.state.selectOptions}
                            handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                            defaultItem={this.state.selectedcolumn}
                            defaultText="Select Filter"
                            defaultName={this.state.selectedcolumn}
                            controlID="1"
                            id="ddlselected"
                          />
                        </div>
                      </div>
                    </div>

                    </div>
                  </div>
                  
                  {/* Orders Tree */}
                  {(() => {
                    const filteredOrders = this.getFilteredOrders();
                    console.log('Filtered Orders:', filteredOrders);
                    console.log('All customer data:', this.state.customeroverviewdata);
                    console.log('All parts data:', this.state.partoverviewdata);
                    console.log('All jobs data:', this.state.joboverviewdata);
                    console.log('All overview data:', this.state.overviewdata);
                    return filteredOrders;
                  })()
                    .map((order, index) => (
                      <div key={order.orderId} className="tree-node">
                        <div 
                          className={`tree-node-header ${this.state.expandedNodes[`order-${order.orderId}`] ? 'active' : ''}`}
                          onClick={() => {
                            this.toggleNode(`order-${order.orderId}`);
                            this.selectOrder(order);
                          }}
                        >
                          <FaChevronRight 
                            className={`tree-node-icon ${this.state.expandedNodes[`order-${order.orderId}`] ? 'expanded' : ''}`}
                          />
                          <span className="tree-node-title">
                            Order #{order.customerOrder || order.orderId}
                          </span>
                          <span className="tree-node-count">
                            {this.state.overviewdata
                              .filter(p => p.orderId === order.orderId && p.partNumber && p.partNumber !== "")
                              .filter((part, index, self) => 
                                index === self.findIndex(p => p.productId === part.productId)
                              ).length} Parts
                          </span>
                          {(() => {
                            // Check if this order has any jobs
                            const hasJobs = this.state.overviewdata.some(item => 
                              item.orderId === order.orderId && 
                              item.jobNumber && 
                              item.jobNumber !== ""
                            );
                            
                            if (!hasJobs) {
                              return <span className="badge badge-pill badge-danger ml-2" style={{backgroundColor: '#dc3545', color: 'white !important'}}>Job Missing</span>;
                            }
                            return null;
                          })()}
                        </div>
                        
                        {this.state.expandedNodes[`order-${order.orderId}`] && (
                          <div className="tree-node-content">
                            {/* Parts for this order */}
                            {(() => {
                              // Get unique parts for this order only
                              const partsForOrder = this.state.overviewdata
                                .filter(part => part.orderId === order.orderId && part.partNumber && part.partNumber !== "")
                                .filter((part, index, self) => 
                                  index === self.findIndex(p => p.productId === part.productId)
                                );
                              console.log(`Parts for order ${order.orderId} (${order.customerOrder}):`, partsForOrder);
                              return partsForOrder;
                            })()
                              .map((part, partIndex) => (
                                <div key={part.productId} className="tree-sub-node">
                                  <div 
                                    className="tree-sub-node-title"
                                    onClick={() => this.selectPart(part)}
                                  >
                                    Part: {part.partNumber} - {part.partName}
                                    {(() => {
                                      // Check if this part has any jobs
                                      const hasJobs = this.state.overviewdata.some(item => 
                                        item.orderId === order.orderId && 
                                        item.productId === part.productId && 
                                        item.jobNumber && 
                                        item.jobNumber !== ""
                                      );
                                      
                                      if (!hasJobs) {
                                        return <span className="badge badge-pill badge-warning ml-2">No Job Created</span>;
                                      }
                                      return null;
                                    })()}
                                  </div>
                                  <div className="tree-sub-node-details">
                                    Qty: {part.qtyOrdered}
                                  </div>
                                  
                                  {/* Jobs for this part */}
                                  {(() => {
                                    // Get unique jobs for this specific part only
                                    const jobsForPart = this.state.overviewdata
                                      .filter(job => job.orderId === order.orderId && job.productId === part.productId && job.jobNumber && job.jobNumber !== "")
                                      .filter((job, index, self) => 
                                        index === self.findIndex(j => j.jobId === job.jobId)
                                      );
                                    console.log(`Jobs for part ${part.productId} in order ${order.orderId}:`, jobsForPart);
                                    return jobsForPart;
                                  })()
                                    .map((job, jobIndex) => (
                                      <div key={job.jobId} className="tree-sub-node" style={{ marginLeft: '1rem', marginTop: '0.25rem' }}>
                                        <div 
                                          className="tree-sub-node-title"
                                          onClick={() => this.selectJob(job)}
                                        >
                                          Job: {job.jobNumber}
                                        </div>
                                        <div className="tree-sub-node-details">
                                          Status: {job.status || 'Active'}
                                        </div>
                                        
                                        {/* Material > Vendor Order Group */}
                                        {this.state.overviewdata
                                          .filter(item => item.orderId === order.orderId && item.productId === part.productId && item.jobId === job.jobId && item.material && item.material !== "")
                                          .filter((item, index, self) => 
                                            index === self.findIndex(i => i.material === item.material)
                                          )
                                          .map((material, materialIndex) => (
                                            <div key={`material-${materialIndex}`} className="tree-sub-node" style={{ marginLeft: '2rem', marginTop: '0.25rem' }}>
                                              <div className="tree-sub-node-title">
                                                Material: {material.material}
                                              </div>
                                              <div className="tree-sub-node-details">
                                                {material.materialId || ''}
                                              </div>
                                              
                                              {/* Vendor Order Group */}
                                              {(() => {
                                                const vendorOrdersForMaterial = this.state.overviewdata
                                                  .filter(item => item.orderId === order.orderId && item.productId === part.productId && item.jobId === job.jobId && item.vendorOrder && item.vendorOrder !== "")
                                                  .filter((item, index, self) => 
                                                    index === self.findIndex(i => i.vendorOrder === item.vendorOrder)
                                                  );
                                                
                                                if (vendorOrdersForMaterial.length > 0) {
                                                  return (
                                                    <div className="tree-sub-node" style={{ marginLeft: '1rem', marginTop: '0.25rem' }}>
                                                      <div className="tree-sub-node-title">
                                                        Vendor Order
                                                      </div>
                                                      {vendorOrdersForMaterial.map((vendorOrder, vendorIndex) => (
                                                        <div key={`vendor-${vendorIndex}`} className="tree-sub-node" style={{ marginLeft: '1rem', marginTop: '0.25rem' }}>
                                                          <div className="tree-sub-node-title">
                                                            {vendorOrder.vendorOrder}
                                                          </div>
                                                          <div className="tree-sub-node-details">
                                                            Vendor: {vendorOrder.vendorName || 'N/A'} | Status: {vendorOrder.vendorStatus || 'Pending'}
                                                          </div>
                                                        </div>
                                                      ))}
                                                    </div>
                                                  );
                                                }
                                                return null;
                                              })()}
                                            </div>
                                          ))}

                                        {/* Process Group */}
                                        {(() => {
                                          const processesForJob = this.state.overviewdata
                                            .filter(item => item.orderId === order.orderId && item.productId === part.productId && item.jobId === job.jobId && item.process && item.process !== "")
                                            .filter((item, index, self) => 
                                              index === self.findIndex(i => i.process === item.process)
                                            );
                                          
                                          if (processesForJob.length > 0) {
                                            return (
                                              <div className="tree-sub-node" style={{ marginLeft: '2rem', marginTop: '0.25rem' }}>
                                                <div className="tree-sub-node-title">
                                                  Process
                                                </div>
                                                {processesForJob.map((process, processIndex) => (
                                                  <div key={`process-${processIndex}`} className="tree-sub-node" style={{ marginLeft: '1rem', marginTop: '0.25rem' }}>
                                                    <div className="tree-sub-node-title">
                                                      {process.process}
                                                      {process.trackerStatus != '' && process.trackerStatus != 'NCR' &&
                                                        <span className="badge badge-pill badge-primary color-green"> {process.trackerStatus == "progress" ? "running" : process.trackerStatus} </span>
                                                      }
                                                      {process.ncr != '' &&
                                                        <span className="badge badge-pill badge-primary color-red"> {process.ncr} </span>
                                                      }
                                                    </div>
                                                    <div className="tree-sub-node-details">
                                                      {/* Process details without ID */}
                                                    </div>
                                                  </div>
                                                ))}
                                              </div>
                                            );
                                          }
                                          return null;
                                        })()}

                                        {/* Shipping Group */}
                                        {(() => {
                                          const shippingForJob = this.state.overviewdata
                                            .filter(item => item.orderId === order.orderId && item.productId === part.productId && item.jobId === job.jobId && item.shipping && item.shipping !== "")
                                            .filter((item, index, self) => 
                                              index === self.findIndex(i => i.shipping === item.shipping)
                                            );
                                          
                                          if (shippingForJob.length > 0) {
                                            return (
                                              <div className="tree-sub-node" style={{ marginLeft: '2rem', marginTop: '0.25rem' }}>
                                                <div className="tree-sub-node-title">
                                                  Shipping
                                                </div>
                                                {shippingForJob.map((shipping, shippingIndex) => (
                                                  <div key={`shipping-${shippingIndex}`} className="tree-sub-node" style={{ marginLeft: '1rem', marginTop: '0.25rem' }}>
                                                    <div className="tree-sub-node-title">
                                                      {shipping.shipping}
                                                    </div>
                                                    <div className="tree-sub-node-details">
                                                      Tracking: {shipping.trackingNumber || 'N/A'} | Status: {shipping.shippingStatus || 'In Transit'}
                                                    </div>
                                                  </div>
                                                ))}
                                              </div>
                                            );
                                          }
                                          return null;
                                        })()}

                                        {/* Invoice Group */}
                                        {(() => {
                                          const invoicesForJob = this.state.overviewdata
                                            .filter(item => item.orderId === order.orderId && item.productId === part.productId && item.jobId === job.jobId && item.invoice && item.invoice !== "")
                                            .filter((item, index, self) => 
                                              index === self.findIndex(i => i.invoice === item.invoice)
                                            );
                                          
                                          if (invoicesForJob.length > 0) {
                                            return (
                                              <div className="tree-sub-node" style={{ marginLeft: '2rem', marginTop: '0.25rem' }}>
                                                <div className="tree-sub-node-title">
                                                  Invoice
                                                </div>
                                                {invoicesForJob.map((invoice, invoiceIndex) => (
                                                  <div key={`invoice-${invoiceIndex}`} className="tree-sub-node" style={{ marginLeft: '1rem', marginTop: '0.25rem' }}>
                                                    <div className="tree-sub-node-title">
                                                      {invoice.invoice}
                                                    </div>
                                                    <div className="tree-sub-node-details">
                                                      Amount: ${invoice.amount || '0'} | Status: {invoice.invoiceStatus || 'Pending'}
                                                    </div>
                                                  </div>
                                                ))}
                                              </div>
                                            );
                                          }
                                          return null;
                                        })()}
                                      </div>
                                    ))}
                                </div>
                              ))}
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              )}

              {/* Card View */}
              {this.state.viewMode === 'cards' && true &&




                <ToolkitProvider
                  keyField="orderId"
                  data={

                    this.state.customeroverviewdata.filter((ele, ind) => ind === this.state.customeroverviewdata.findIndex(elem => elem.orderId === ele.orderId))
                  }
                  columns={columns}

                  search
                >
                  {(props: {
                    searchProps: JSX.IntrinsicAttributes;
                    baseProps: JSX.IntrinsicAttributes;
                  }) => (
                    <>
                      <div className='row g-1'>
                        <section className="d-flex flex-wrap gap-3 pb-2">
                          <div className="position-relative">
                            <SearchBar {...props.searchProps} autoComplete={false} />
                          </div>

                          <div
                          //className="input-group w-auto"
                          className='col-12 col-md-2'
                          >
                              <SingleDropdownListWithoutSearch

                                itemList={this.state.selectOptions}
                               handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                                defaultItem={this.state.selectedcolumn}
                                defaultText={"Select Filter"}
                                defaultName={this.state.selectedcolumn}
                                controlID="1"
                                id={"ddlselected"}

                              />
                          </div>
                          <div style={{paddingTop:'5px'}}>
                          {this.state.showMessage}
                          </div>
                        </section>

                      </div>
                      <div className='row g-1'>
                        <div className="col-1 widthspl125">
                          <div className="table-responsive"  >



                            <div className="section" style={{ display: "flex" }}>
                              <div className="overview-settings d-flex justify-content-start">
                                <div className="left-panel">
                                  <section >
                                    <div className="search-header">
                                     Order No.
                                    </div>
                                    <div className="left-body">
                                      <BootstrapTable

                                        {...props.baseProps}

                                        hover
                                        condensed

                                        selectRow={{
                                          mode: 'radio',
                                          clickToSelect: true,
                                          classes: "table-active1",
                                          // style: { backgroundColor: '#c8e6c9' },
                                          hideSelectColumn: true,
                                          onSelect: this.handleTemplateOnSelect,
                                          selected: [this.state.selectedTemplateId],
                                        }}
                                      />
                                    </div>
                                  </section>
                                </div>
                              </div>
                            </div>


                          </div>



                        </div>
                        <div className="col-1 widthspl125">
                          <div className="table-responsive"  >

                            {true &&







                              <div className="section" style={{ display: "flex" }}>
                                <div className="overview-settings d-flex justify-content-start">
                                  <div className="left-panel">

                                    <section >
                                      <div className="search-header">
                                        Part No.
                                      </div>
                                      <div className="left-body">
                                        <BootstrapTable

                                          keyField="productId"
                                          data={
                                            // this.state.overviewdata
                                            this.state.partoverviewdata.filter((ele, ind) => ind === this.state.partoverviewdata.findIndex(elem => elem.partNumber === ele.partNumber) && ele.partNumber != "" && ele.orderId == this.state.selectedTemplateId)
                                          }
                                          columns={this.state.partcolumns}

                                          hover
                                          condensed

                                          selectRow={{
                                            mode: 'radio',
                                            clickToSelect: true,
                                            classes: "table-active1",
                                            // style: { backgroundColor: '#c8e6c9' },
                                            hideSelectColumn: true,
                                            onSelect: this.handlepartOnSelect,
                                            selected: [this.state.partselected],
                                          }}
                                        />
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>




                            }

                          </div>



                        </div>
                        <div className="col-1 widthspl125">
                          <div className="table-responsive"  >

                            {true &&







                              <div className="section" style={{ display: "flex" }}>
                                <div className="overview-settings d-flex justify-content-start">
                                  <div className="left-panel">



                                    <section >
                                      <div className="search-header">
                                        Job No.
                                      </div>
                                      <div className="left-body">
                                        <BootstrapTable

                                          keyField="jobId"
                                          data={
                                            // this.state.overviewdata
                                            this.state.joboverviewdata.filter((ele, ind) => ind === this.state.joboverviewdata.findIndex(elem => elem.jobNumber === ele.jobNumber) && ele.jobNumber != "" && ele.orderId == this.state.selectedTemplateId)
                                          }
                                          columns={this.state.jobcolumns}

                                          hover
                                          condensed

                                          selectRow={{
                                            mode: 'radio',
                                            clickToSelect: true,
                                            classes: "table-active1",
                                            // style: { backgroundColor: '#c8e6c9' },
                                            hideSelectColumn: true,
                                            onSelect: this.handlejobOnSelect,
                                            selected: [this.state.jobselected],
                                          }}
                                        />
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>




                            }

                          </div>



                        </div>

                        <div className="col-1 widthspl">
                          <div className="table-responsive"  >

                            {true &&







                              <div className="section" style={{ display: "flex" }}>
                                <div className="overview-settings d-flex justify-content-start">
                                  <div className="left-panel">



                                    <section >
                                      <div className="search-header">
                                        Material
                                      </div>
                                      <div className="left-body">
                                        <BootstrapTable

                                          keyField="jobId"
                                          data={
                                            // this.state.overviewdata
                                            //  this.state.overviewdata.filter((ele, ind) => ind === this.state.overviewdata.findIndex(elem => elem.material === ele.material &&  elem.orderId == this.state.selectedTemplateId) && ele.material != "" && ele.orderId == this.state.selectedTemplateId )
                                            this.state.overviewdata.filter((ele, ind) => ind === this.state.overviewdata.findIndex(elem => elem.material === ele.material && elem.jobNumber === ele.jobNumber && elem.orderId == this.state.selectedTemplateId) && ele.material != "" && ele.orderId == this.state.selectedTemplateId)
                                            // this.state.overviewdata.filter(ele => ele.material != "" && ele.orderId == this.state.selectedTemplateId)

                                          }
                                          columns={this.state.mcolumns}

                                          hover
                                          condensed

                                          selectRow={{
                                            mode: 'radio',
                                            clickToSelect: true,
                                            classes: "table-active1",
                                            // style: { backgroundColor: '#c8e6c9' },
                                            hideSelectColumn: true,
                                            onSelect: this.handleMaterialOnSelect,
                                            selected: [this.state.jobselected],
                                          }}
                                        />
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>





                            }

                          </div>



                        </div>

                        <div className="col-1 widthspl200">
                          <div className="table-responsive"  >

                            {true &&






                              <div className="section" style={{ display: "flex" }}>
                                <div className="overview-settings d-flex justify-content-start">
                                  <div className="left-panel">



                                    <section >
                                      <div className="search-header">
                                        Process
                                      </div>
                                      <div className="left-body">
                                        <BootstrapTable

                                          keyField="jobId"
                                          data={
                                            // this.state.overviewdata
                                            this.state.overviewdata.filter((ele, ind) => ind === this.state.overviewdata.findIndex(elem => elem.processId === ele.processId && elem.jobdetailsid === ele.jobdetailsid && elem.orderId == this.state.selectedTemplateId && elem.productId == this.state.partselected) && ele.process != "" && ele.orderId == this.state.selectedTemplateId && ele.productId == this.state.partselected)
                                            // this.state.overviewdata.filter(ele=> ele.orderId == this.state.selectedTemplateId && ele.jobId==this.state.jobselected && ele.productId==this.state.partselected && ele.process != "")
                                          }
                                          columns={this.state.pcolumns}

                                          hover
                                          condensed

                                          selectRow={{
                                            mode: 'checkbox',
                                            clickToSelect: true,
                                            classes: "table-active1",
                                            // style: { backgroundColor: '#c8e6c9' },
                                            hideSelectColumn: true,
                                            onSelect: this.handlepprocessOnSelect,
                                            selected: [this.state.jobselected],
                                          }}
                                        />
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>





                            }

                          </div>



                        </div>

                        <div className="col-1 widthspl">
                          <div className="table-responsive"  >

                            {true &&







                              <div className="section" style={{ display: "flex" }}>
                                <div className="overview-settings d-flex justify-content-start">
                                  <div className="left-panel">



                                    <section >
                                      <div className="search-header">
                                        Vendor Order
                                      </div>
                                      <div className="left-body">
                                        <BootstrapTable

                                          keyField="jobId"
                                          data={
                                            // this.state.overviewdata
                                            this.state.overviewdata.filter((ele, ind) => ind === this.state.overviewdata.findIndex(elem => elem.vendorOrder === ele.vendorOrder) && ele.vendorOrder != "" && ele.orderId == this.state.selectedTemplateId && ele.orderId == this.state.selectedTemplateId)
                                          }
                                          columns={this.state.vcolumns}
                                          hover
                                          condensed

                                          selectRow={{
                                            mode: 'radio',
                                            clickToSelect: true,
                                            classes: "table-active1",
                                            // style: { backgroundColor: '#c8e6c9' },
                                            hideSelectColumn: true,
                                            onSelect: this.handleVendorOnSelect,
                                            selected: [this.state.jobselected],
                                          }}
                                        />
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>





                            }

                          </div>



                        </div>

                        <div className="col-1 widthspl">
                          <div className="table-responsive"  >

                            {true &&






                              <div className="section" style={{ display: "flex" }}>
                                <div className="overview-settings d-flex justify-content-start">
                                  <div className="left-panel">



                                    <section >
                                      <div className="search-header">
                                        Shipping
                                      </div>
                                      <div className="left-body">
                                        <BootstrapTable

                                          keyField="shipmentid"
                                          data={
                                            // this.state.overviewdata
                                            this.state.overviewdata.filter((ele, ind) => ind === this.state.overviewdata.findIndex(elem => elem.shipping === ele.shipping && elem.orderId == this.state.selectedTemplateId && elem.shipping != "") && ele.shipping != "" && ele.orderId == this.state.selectedTemplateId && ele.shipping != "")
                                          }
                                          columns={this.state.scolumns}

                                          hover
                                          condensed

                                          selectRow={{
                                            mode: 'radio',
                                            clickToSelect: true,
                                            classes: "table-active1",
                                            // style: { backgroundColor: '#c8e6c9' },
                                            hideSelectColumn: true,
                                            onSelect: this.handleShippingOnSelect,
                                            selected: this.state.overviewdata.filter(o => o.jobId == this.state.jobselected).map(r => r.shipmentid),
                                          }}
                                        />
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>





                            }

                          </div>



                        </div>

                        <div className="col-1 widthspl180">
                          <div className="table-responsive"  >

                            {true &&






                              <div className="section" style={{ display: "flex" }}>
                                <div className="overview-settings d-flex justify-content-start">
                                  <div className="left-panel">



                                    <section >
                                      <div className="search-header">
                                        Invoice
                                      </div>
                                      <div className="left-body">
                                        <BootstrapTable

                                          keyField="invoiceId"
                                          data={
                                            // this.state.overviewdata
                                            this.state.invoverviewdata.filter((ele, ind) => ind === this.state.invoverviewdata.findIndex(elem => elem.invoice === ele.invoice) && ele.invoice != "" && ele.orderId == this.state.selectedTemplateId && ele.invoice != "")
                                          }
                                          columns={this.state.icolumns}

                                          hover
                                          condensed

                                          selectRow={{
                                            mode: 'checkbox',
                                            clickToSelect: true,
                                            classes: "table-active1",
                                            // style: { backgroundColor: '#c8e6c9' },
                                            hideSelectColumn: true,
                                            onSelect: this.handleInvoiceOnSelect,
                                            selected: this.state.invoverviewdata.filter(o => o.productId == this.state.partselected).map(r => r.invoiceId),
                                          }}
                                        />
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>





                            }

                          </div>



                        </div>



                      </div>
                    </>
                  )
                  }
                </ToolkitProvider>
              }
            </section>
            )}
          </section>
          {(showSlideout &&

            <Vendororderslideout
              closeSlideOut={this.closeSlideOut}
              orderid={this.state.orderid}
              receivedStatus={this.state.receivedStatus}
              CustomerPoNumber={this.state.customerpo}
              poNumber={this.state.poNumber}
              productid={this.state.productid}
              partname={this.state.partname}
              partNo={this.state.partNo}
              qtyOrdered={this.state.qtyOrdered}
              jobid={this.state.jobid}
              itemNo={this.state.itemNo}
              vendororderid={this.state.vendororderid}
              vendorordertype={this.state.vendorordertype}
              selectedCustomer={this.state.selectedCustomer}
              orderdate={this.state.orderdate}
              dueDate={this.state.dueDate}
              jobDesc={this.state.jobDesc}
              id={this.state.id}
            >


            </Vendororderslideout>


          )}

          {showJobSlideout && (

            <JobCreations
              closeSlideOut={this.closeJobSlideout}
              jobid={this.state.jobid}
              orderid={this.state.orderid}
              CustomerPoNumber={this.state.CustomerPoNumber}
              poNumber={this.state.poNumber}
              productid={this.state.productid}
              partname={this.state.partname}
              partNo={this.state.partNo}
              qtyOrdered={this.state.qtyOrdered}

              itemNo={this.state.itemNo}
              selectedCustomer={this.state.selectedCustomer}
              orderdate={this.state.orderdate}
              dueDate={this.state.dueDate}
              jobDesc={this.state.jobDesc}
              id={this.state.orderdetailid}

            >
            </JobCreations>
          )}

          {(showReceivableslideout &&
            <Receivableslideout
              closeSlideOut={this.closeInvoiceSlideOut}
              orderid={this.state.orderid}
              orderIds={this.state.orderIds}
              products={this.state.products}
              invoiceId={this.state.invoiceId}
            >


            </Receivableslideout>
          )}


          {showNCRSlideout && (

            <NCRSlideout
              closeSlideOut={this.closeSlideOut}
              jobid={this.state.jobid}
              id={this.state.id}
              jobno={this.state.jobno}

            >
            </NCRSlideout>
          )}

          {(showShippingSlideout &&
            <ShippingSlideout
              closeSlideOut={this.closeSlideOut}
              orderid={this.state.orderid}
              jobids={this.state.jobIds}
              shipmentId={this.state.shipmentid}
            >


            </ShippingSlideout>
          )}

          {(showCustomerSlideout &&
            <Customerorderslideout
              closeSlideOut={this.closeSlideOut}
              orderid={this.state.orderid}
            >


            </Customerorderslideout>
          )}

        </Container>


      </>
    );
  }
}
